function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Component_10",
  "data-name": "Component 10",
  transform: "translate(0.5 0.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_354",
  "data-name": "Group 354",
  transform: "translate(-2 -2)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_211",
  "data-name": "Group 211",
  transform: "translate(8.518 8.518)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_209",
  "data-name": "Group 209",
  transform: "translate(0.318)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_23",
  "data-name": "Line 23",
  y1: 1.814,
  x2: 1.814,
  transform: "translate(9.513)",
  fill: "none",
  stroke: "#566FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_24",
  "data-name": "Line 24",
  y1: 8.782,
  x2: 8.145,
  transform: "translate(0 3.182)",
  fill: "none",
  stroke: "#566FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_210",
  "data-name": "Group 210",
  transform: "translate(0 0.318)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_285",
  "data-name": "Path 285",
  d: "M641.242,326.108l-8.782-8.145-1.368-1.368-1.814-1.814",
  transform: "translate(-629.279 -314.781)",
  fill: "none",
  stroke: "#566FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}))), /*#__PURE__*/React.createElement("path", {
  id: "Path_330",
  "data-name": "Path 330",
  d: "M875.394,222.15v-5.4h25v25h-25v-15.3",
  transform: "translate(-873.394 -214.747)",
  fill: "none",
  stroke: "#566FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})));

var SvgJoratoCasesReservedLightBlue = function SvgJoratoCasesReservedLightBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJoratoCasesReservedLightBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jorato-cases-reserved-light-blue.ed5866d0.svg";
export { ForwardRef as ReactComponent };